import StockoutCustomFieldSearchDialog from "./stockoutCustomFieldSearchDialog.container";

export default StockoutCustomFieldSearchDialog;